module.exports = __webpack_public_path__ + "static/media/bg-artesana.77f49fc5.svg";